<template>
  <div v-if="brandbar_show">
    <!--//@*/*
    //    *BCS  CSIG App v0.91
    //    * Copyright (c) 2024, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->

    <div
      id="v-app-bar--contatiner"
      class="d-flex"
      style="width: 100%; height: 48px"
    >
      <v-navigation-drawer
        id="v-navigation-drawer"
        height="50"
        v-model="drawer"
        temporary
        absolute
      >
        <v-list nav dense close-on-click close-on-content-click>
          <v-list-item-group v-model="group" active-class="primary white--text">
            <v-list-item @click.prevent="getcsv">
              <v-list-item-icon>
                <v-icon color="blue darken-4">$file</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Get CSV</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>
      <v-app-bar
        fixed
        app
        class="mx-auto white darken-5"
        absolute
        dense
        style="
          background-color: #002e42 !important;
          color: white !important;
          max-width: 768px;
        "
      >
        <v-app-bar-nav-icon
          style="visibility: hidden"
          v-show="true"
          x-large
          @click="drawer = true"
        ></v-app-bar-nav-icon>
        <v-spacer></v-spacer>

        <v-img
          max-width="166"
          height="80%"
          width="auto"
          src="../images/badgesex150_40_3_white.png"
          style="margin-left: 8px"
        ></v-img>
        <v-spacer></v-spacer>
        <div id="div_logoff" style="visibility: hidden">
          <v-btn icon text v-show="true" @click="toggle_logoff">
            <v-icon x-large>$person</v-icon>
          </v-btn>
        </div>
      </v-app-bar>
    </div>

    <div
      id="app-title-container"
      style="width: 100%; height: 24px"
      class="d-flex"
    >
      <v-spacer></v-spacer>
      <div
        id="apptitle"
        style="
          background-color: #002e42 !important;
          color: white !important;
          max-width: 768px;
          width: 100%;
          height: 30px;

          vertical-align: middle;
        "
        class="d-flex justify-center my-2"
      >
        <span class="text-h6">{{ app_title }}</span>
      </div>

      <v-spacer></v-spacer>
    </div>

    <div
      id="logoff-popup"
      class="text-white"
      @click="logoff"
      style="
        z-index: 500;
        background-color: aliceblue;
        text-decoration: underline;
        cursor: pointer;
        position: absolute;
        top: 40px;
        right: 50px;
        padding: 10px;
        border-radius: 4px;
      "
      v-if="showLogoff"
    >
      Logoff: {{ user_email }}
    </div>
  </div>
</template>

<script>
export default {
  name: "brandbar",
  data: function () {
    return {
      brandbar_show: true,
      showLogoff: false,
      user_email: "",
      app_title: "RPD Award Nomination",
      drawer: false,
      group: null,
    };
  },
  watch: {
    "$store.state.user": function () {
      //keep this
      if (this.$store.state.user != "") {
        this.user_email = this.$store.state.user.email;
      } else {
        this.user_email = "UNKNOWN";
      }
    },
    "$store.state.brandbar_show": function () {
      this.brandbar_show = this.$store.state.brandbar_show;
    },
  },
  methods: {
    getcsv() {
      this.drawer = false;

      //   window.open("https://csig.renopdportal.org/api/csv", "_blank");
      // this.$router.push("/csvdown/?token=" + this.$store.state.user.token);
    },
    menu_home() {
      this.$router.push("/?token=" + this.$store.state.user.token);
    },
    menu_help() {
      this.$router.push("/help?token=" + this.$store.state.user.token);
    },
    toggle_logoff() {
      this.showLogoff = !this.showLogoff;
    },
    logoff() {
      //   window.location.replace("https://rpdportal.org/");
    },
  },
};
</script>

<style scoped>
/* .drawer_pos {

} */
i.v-icon.v-icon {
  color: red;
}

.v-icon {
  color: #ffffff !important;
}
</style>
